import templateUrl from "emun.invoice/inv/inv-list-cards.htm";

export default () => ({ templateUrl });
